import React, { Component } from 'react';
import { Grid, Button, TextField, MenuItem } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { DatePicker } from 'material-ui-pickers';
import moment from 'moment';

import AircraftsTypesService from '../../tools/AircraftsTypesService';
import AircraftsService from '../../tools/AircraftsService';

import { msgSimple, msgAction } from '../../actions/snackbarActions';
import { connect } from 'react-redux';

class DialogSearch extends Component {
    constructor(props) {
        super(props)
        this.state = {
            search: {
                passenger: '',
                aircraft: '',
                aircraft_type: '',
                from: '',
                to: '',
                initial_date: null,
                final_date: null
            },
            aircraftOptions: [],
            aircraftTypes: []
        }
    }

    onEnter = () => {
        //console.log(this.props.openSearch)


        AircraftsTypesService.getActive().then(result => {
            if (result.ok) {
                this.setState({ aircraftTypes: result.response });
            }
        })
        AircraftsService.getActive().then(result => {
            if (result.ok) {
                this.setState({ aircraftOptions: result.response });
            }
        })
    }

    clean = ()=>{
        this.setState({
                search:{
                    passenger: '',
                    aircraft: '',
                    aircraft_type: '',
                    from: '',
                    to: '',
                    initial_date: null,
                    final_date: null
                }
        })
    }



    render() {
        return (
            <Dialog
                open={this.props.openSearch}
                maxWidth={'sm'}
                onEnter={this.onEnter}
            >
                <DialogTitle id="alert-dialog-title">{"Pesquisa personalizada"}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={8}>
                    <Grid container justify='flex-end'>
                        <Button onClick={this.clean} color="primary" style={{float:'right'}}>
                            Limpar Filtros
                        </Button>
                    </Grid>
                        <Grid container>
                            <TextField
                                label="Pesquisar por Passageiro"
                                style={{ width: '100%' }}
                                value={this.state.search.passenger}
                                onChange={event => {
                                    let { search } = this.state
                                    this.setState({ search: { ...search, passenger: event.target.value } })
                                }}
                                margin="normal"
                            >
                            </TextField>

                        </Grid>
                        {/* <Grid container>
                            <TextField
                                select
                                label="Pesquisar por Aeronave"
                                style={{ width: '100%' }}
                                value={this.state.search.aircraft}
                                onChange={event => {
                                    let { search } = this.state
                                    this.setState({ search: { ...search, aircraft: event.target.value } })
                                }}
                                margin="normal"
                            >
                                <MenuItem disabled>
                                    Selecione a Aeronave
                                            </MenuItem>
                                {this.state.aircraftOptions.map(option => (
                                    <MenuItem key={option.id} value={option.marks}>
                                        {option.marks}
                                    </MenuItem>
                                ))}
                            </TextField>

                        </Grid>
                        <Grid container >
                            <TextField
                                select
                                label="Pesquisar por Tipo de Aeronave"
                                style={{ width: '100%' }}
                                value={this.state.search.aircraft_type}
                                onChange={event => {
                                    let { search } = this.state
                                    this.setState({ search: { ...search, aircraft_type: event.target.value } })
                                }}
                                margin="normal"
                            >
                                <MenuItem disabled>
                                    Selecione o Tipo
                                            </MenuItem>
                                {this.state.aircraftTypes.map(option => (
                                    <MenuItem key={option.id} value={option.type}>
                                        {option.type}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid> */}
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <TextField
                                label="Pesquisar por Origem"
                                style={{ width: '100%' }}
                                value={this.state.search.from}
                                onChange={event => {
                                    let { search } = this.state
                                    this.setState({ search: { ...search, from: event.target.value } })
                                }}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <TextField
                                label="Pesquisar por Destino"
                                style={{ width: '100%' }}
                                value={this.state.search.to}
                                onChange={event => {
                                    let { search } = this.state
                                    this.setState({ search: { ...search, to: event.target.value } })
                                }}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <MuiPickersUtilsProvider
                                utils={MomentUtils}
                                moment={moment}
                                locale='pt-br'
                            >
                                <DatePicker
                                    style={{ width: '100%' }}
                                    label="Data de início"
                                    format='DD/MM/YYYY'
                                    clearable
                                    clearLabel='LIMPAR'
                                    cancelLabel='SAIR'
                                    okLabel='OK'
                                    value={this.state.search.initial_date}
                                    onChange={date => {
                                        //console.log(date)
                                        let { search } = this.state
                                        this.setState({ search: { ...search, initial_date: date } })
                                    }}
                                    animateYearScrolling
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <MuiPickersUtilsProvider
                                utils={MomentUtils}
                                moment={moment}
                                locale='pt-br'
                            >
                                <DatePicker
                                    style={{ width: '100%' }}
                                    label="Data final"
                                    format='DD/MM/YYYY'
                                    clearable
                                    clearLabel='LIMPAR'
                                    cancelLabel='SAIR'
                                    okLabel='OK'
                                    value={this.state.search.final_date}
                                    onChange={date => {
                                        let {search} = this.state
                                        this.setState({ search:{...search,final_date: date} })
                                    }}
                                    animateYearScrolling
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleOpenDialog} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={() => {
                        // this.props.msgSimple('Pesquisa ainda não habilitada.')
                        // this.props.handleOpenDialog()
                        this.props.handleCustomSearch(this.state.search)
                    }} color="primary" autoFocus>
                        Pesquisar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
    msgSimple,
    msgAction
};

export default connect(mapStateToProps, mapDispatchToProps)(DialogSearch)


// WEBPACK FOOTER //
// ./src/routes/home/DialogSearch.js